import { viandas2Get } from "../../../common/service/viandas2Client";

export const getPedidosRRHH = (filtros = {}) => viandas2Get("/rrhh/pedidos", filtros);

export const getUsuariosPedidos = () => viandas2Get("/rrhh/pedidos/usuarios");
